module.exports = __webpack_public_path__ + "static/assets/3683e23b8be8e893db34f3430d3c0595.png";